module.exports = __webpack_public_path__ + "static/blue-arrow-ba7614680e9fbbdb107bcf638d0d6870.svg";